import {
    Tableau,
    TableauBody,
    TableauCell,
    TableauHeader,
    TableauHeaderCell,
    TableauRow,
} from '@si-armes/dsfr-react';

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { comparerDeuxDates } from '../../../../utils/utils';

const TableauMunition = ({ munitions }) => {
    const entete = [
        { field: 'numEncodage', header: "Numéro d'encodage" },
        { field: 'calibreCanon', header: 'Calibre' },
        { field: 'dateMiseEnStock', header: "Date d'acquisition", sort: comparerDeuxDates },
        { field: 'periodeQuota', header: 'Période', sort: comparerDeuxDates },
        {
            field: 'quotaUtiliseMunition',
            header: 'Quota',
        },
    ];
    const [ordreTri, setOrdreTri] = useState('ASC');
    const [champTri, setChampTri] = useState(entete[0]);

    const donneesTriees = useMemo(() => {
        if (!munitions?.records) {
            return [];
        }

        const sort = champTri.sort ?? ((a, b) => a < b);

        return munitions?.records.sort((a, b) => {
            if (sort(a[champTri.field], b[champTri.field])) return ordreTri === 'ASC' ? -1 : 1;
            if (sort(b[champTri.field], a[champTri.field])) return ordreTri === 'ASC' ? 1 : -1;
            return 0;
        });
    }, [munitions, ordreTri, champTri]);

    return (
        <Tableau
            avecBordure
            role="table"
            caption="Munitions du détenteur - Appuyer sur un entete pour trier la colonne associée"
            noCaption
        >
            <TableauHeader>
                <TableauRow>
                    {entete.map((title) => (
                        <TableauHeaderCell
                            ordreTri={champTri.field === title.field ? ordreTri : undefined}
                            onClick={() => {
                                if (champTri.field === title.field) {
                                    setOrdreTri((old) => (old === 'ASC' ? 'DESC' : 'ASC'));
                                } else {
                                    setOrdreTri('ASC');
                                    setChampTri(title);
                                }
                            }}
                            scope="col"
                            key={title.field}
                        >
                            {title.header}
                        </TableauHeaderCell>
                    ))}
                </TableauRow>
            </TableauHeader>
            <TableauBody>
                {donneesTriees.map((munition) => {
                    return (
                        <>
                            <TableauRow>
                                <TableauCell>{munition.numEncodage}</TableauCell>
                                <TableauCell>{munition.calibreCanon}</TableauCell>
                                <TableauCell>{munition.dateMiseEnStock}</TableauCell>
                                <TableauCell>{munition.periodeQuota}</TableauCell>
                                <TableauCell>
                                    {munition.quotaUtiliseMunition ?? 0}/
                                    {munition.quotaMunitions ?? 'non spécifié'}
                                </TableauCell>
                            </TableauRow>
                        </>
                    );
                })}
            </TableauBody>
        </Tableau>
    );
};

TableauMunition.propTypes = {
    munitions: PropTypes.array.isRequired,
};

export default TableauMunition;
